export default __webpack_public_path__ + "static/media/io.484f650e.svg";